// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-create-wrapper {
  overflow-x: hidden;
  box-sizing: border-box;
  max-height: calc(100vh - 100px);
  /* Ensure step-4 layout fits the viewport and inner columns scroll correctly */
}
.event-create-wrapper .menu-wrapper {
  max-height: 200px;
}
.event-create-wrapper .header-container {
  width: 100%;
}
.event-create-wrapper .button-container,
.event-create-wrapper .event-create-container {
  width: 45%;
}
.event-create-wrapper .footer-container {
  width: 100%;
}
.event-create-wrapper.step-4 .full-width {
  width: 100%;
}
.event-create-wrapper.step-4 {
  /* Ensure images and inner content never exceed their container width */
}
.event-create-wrapper.step-4 .event-create-container {
  width: 100%;
  padding-top: 0 !important;
  /* make the container take available height so children can scroll */
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}
.event-create-wrapper.step-4 .event-create-content {
  flex: 1 1 auto;
  display: flex;
  overflow: hidden; /* children will scroll individually */
}
.event-create-wrapper.step-4 .leftMenu, .event-create-wrapper.step-4 .rightContent {
  /* limit height so internal scroll works */
  max-height: calc(100vh - 160px);
  overflow-y: auto;
}
.event-create-wrapper.step-4 img {
  max-width: 100%;
  height: auto;
  display: block;
}

@media screen and (max-width: 650px) {
  ::-webkit-scrollbar {
    display: none !important;
  }
  .event-create-container {
    padding-top: 0px !important;
  }
  .event-create-container .progress-bar-wrapper {
    margin-bottom: 24px !important;
  }
  .event-create-wrapper {
    padding: 24px 24px 0 24px;
    margin-top: 72px !important;
    max-height: calc(100dvh - 72px) !important;
    /* step-4 specific adjustments on small screens */
  }
  .event-create-wrapper .heading-36 {
    font-weight: 600;
    font-size: 24px !important;
    line-height: 32.4px !important;
  }
  .event-create-wrapper .heading-36 ~ div {
    gap: 16px !important;
    padding-right: 0 !important;
  }
  .event-create-wrapper .heading-36.mb-9 {
    margin-bottom: 20px !important;
  }
  .event-create-wrapper .dropzone {
    padding: 0px !important;
    width: 100% !important;
  }
  .event-create-wrapper .dropzone > div {
    padding: 8px !important;
  }
  .event-create-wrapper .displayzone {
    width: 100% !important;
  }
  .event-create-wrapper label {
    font-size: 14px !important;
  }
  .event-create-wrapper .header-container {
    width: 100%;
  }
  .event-create-wrapper .button-container,
  .event-create-wrapper .event-create-container {
    width: 100%;
  }
  .event-create-wrapper .footer-container {
    width: 100%;
    margin-top: 0px !important;
  }
  .event-create-wrapper.step-4 .event-create-container {
    height: calc(100dvh - 72px) !important;
  }
  .event-create-wrapper.step-4 .event-create-content {
    flex-direction: column;
    overflow: auto;
  }
  .event-create-wrapper.step-4 .leftMenu, .event-create-wrapper.step-4 .rightContent {
    max-height: none;
    overflow: visible;
  }
}
@media (max-width: 768px) {
  .event-create-wrapper .modal .modal-container .modal-content {
    padding-bottom: 10px !important;
  }
  .event-create-wrapper .modal .modal-container .modal-footer {
    height: 80px !important;
    min-height: 80px !important;
  }
  .event-create-wrapper .modal .modal-container .modal-footer .secondary-cta,
  .event-create-wrapper .modal .modal-container .modal-footer .primary-cta {
    height: 56px !important;
    min-height: 56px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/event-create/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,+BAAA;EAyBA,8EAAA;AAvBF;AAAE;EACE,iBAAA;AAEJ;AACE;EACE,WAAA;AACJ;AAEE;;EAEE,UAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAKI;EACE,WAAA;AAHN;AAQE;EAqBE,uEAAA;AA1BJ;AAMI;EACE,WAAA;EACA,yBAAA;EACA,oEAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;AAJN;AAOI;EACE,cAAA;EACA,aAAA;EACA,gBAAA,EAAA,sCAAA;AALN;AAQI;EACE,0CAAA;EACA,+BAAA;EACA,gBAAA;AANN;AASI;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAPN;;AAYA;EACE;IACE,wBAAA;EATF;EAYA;IACE,2BAAA;EAVF;EAYE;IACE,8BAAA;EAVJ;EAcA;IACE,yBAAA;IACA,2BAAA;IACA,0CAAA;IAgDA,iDAAA;EA3DF;EAaE;IACE,gBAAA;IACA,0BAAA;IACA,8BAAA;EAXJ;EAaI;IACE,oBAAA;IACA,2BAAA;EAXN;EAcI;IACE,8BAAA;EAZN;EAgBE;IACE,uBAAA;IACA,sBAAA;EAdJ;EAgBI;IACE,uBAAA;EAdN;EAkBE;IACE,sBAAA;EAhBJ;EAmBE;IACE,0BAAA;EAjBJ;EAoBE;IACE,WAAA;EAlBJ;EAqBE;;IAEE,WAAA;EAnBJ;EAsBE;IACE,WAAA;IACA,0BAAA;EApBJ;EAyBI;IACE,sCAAA;EAvBN;EA0BI;IACE,sBAAA;IACA,cAAA;EAxBN;EA2BI;IACE,gBAAA;IACA,iBAAA;EAzBN;AACF;AA8BA;EAEI;IACE,+BAAA;EA7BJ;EAgCE;IACE,uBAAA;IACA,2BAAA;EA9BJ;EA+BI;;IAEE,uBAAA;IACA,2BAAA;EA7BN;AACF","sourcesContent":[".event-create-wrapper {\n  overflow-x: hidden;\n  box-sizing: border-box;\n  max-height: calc(100vh - 100px);\n\n  .menu-wrapper {\n    max-height: 200px;\n  }\n\n  .header-container {\n    width: 100%;\n  }\n\n  .button-container,\n  .event-create-container {\n    width: 45%;\n  }\n\n  .footer-container {\n    width: 100%;  \n  }\n  &.step-4{\n    \n    .full-width{\n      width: 100%;\n    }\n  }\n\n  /* Ensure step-4 layout fits the viewport and inner columns scroll correctly */\n  &.step-4 {\n    .event-create-container {\n      width: 100%;\n      padding-top: 0 !important;\n      /* make the container take available height so children can scroll */\n      height: calc(100vh - 100px);\n      display: flex;\n      flex-direction: column;\n    }\n\n    .event-create-content {\n      flex: 1 1 auto;\n      display: flex;\n      overflow: hidden; /* children will scroll individually */\n    }\n\n    .leftMenu, .rightContent {\n      /* limit height so internal scroll works */\n      max-height: calc(100vh - 160px);\n      overflow-y: auto;\n    }\n    /* Ensure images and inner content never exceed their container width */\n    img {\n      max-width: 100%;\n      height: auto;\n      display: block;\n    }\n  }\n}\n\n@media screen and (max-width: 650px) {\n  ::-webkit-scrollbar {\n    display: none !important;\n  }\n\n  .event-create-container {\n    padding-top: 0px !important;\n\n    .progress-bar-wrapper {\n      margin-bottom: 24px !important;\n    }\n  }\n\n  .event-create-wrapper {\n    padding: 24px 24px 0 24px;\n    margin-top: 72px !important;\n    max-height: calc(100dvh - 72px) !important;\n\n    .heading-36 {\n      font-weight: 600;\n      font-size: 24px !important;\n      line-height: 32.4px !important;\n\n      & ~ div {\n        gap: 16px !important;\n        padding-right: 0 !important;\n      }\n\n      &.mb-9 {\n        margin-bottom: 20px !important;\n      }\n    }\n\n    .dropzone {\n      padding: 0px !important;\n      width: 100% !important;\n\n      > div {\n        padding: 8px !important;\n      }\n    }\n\n    .displayzone {\n      width: 100% !important;\n    }\n\n    label {\n      font-size: 14px !important;\n    }\n\n    .header-container {\n      width: 100%;\n    }\n\n    .button-container,\n    .event-create-container {\n      width: 100%;\n    }\n\n    .footer-container {\n      width: 100%;\n      margin-top: 0px !important;\n    }\n\n    /* step-4 specific adjustments on small screens */\n    &.step-4 {\n      .event-create-container {\n        height: calc(100dvh - 72px) !important;\n      }\n\n      .event-create-content {\n        flex-direction: column;\n        overflow: auto;\n      }\n\n      .leftMenu, .rightContent {\n        max-height: none;\n        overflow: visible;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .event-create-wrapper {\n    .modal .modal-container .modal-content {\n      padding-bottom: 10px !important;\n    }\n\n    .modal .modal-container .modal-footer {\n      height: 80px !important;\n      min-height: 80px !important;\n      .secondary-cta,\n      .primary-cta {\n        height: 56px !important;\n        min-height: 56px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
